import { render, staticRenderFns } from "./InventoryStockOpnameAdd.vue?vue&type=template&id=18630f0f"
import script from "./InventoryStockOpnameAdd.vue?vue&type=script&lang=js"
export * from "./InventoryStockOpnameAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports